// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"tY","sticky_header_title":"uY","stycky_header_title_mob":"vY","root_scroller":"wY","scroller":"xY","indicator":"yY","scrollButtons":"zY","selected":"AY","root_tab_scrollable":"BY","root_scroller_mob":"CY","scroller_mob":"EY","indicator_mob":"FY","selected_mob":"GY","root_tab_mob":"HY","root_tab_mob_scrollable":"IY","sticky_header_title_mob":"JY"};
    if(module.hot) {
      // 1715188239256
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  